import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        const chunkFailedMessage = /Loading chunk [\d]+ failed|ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported module/;
        const errorMessage = error?.message || error?.toString?.() || '';
        if (chunkFailedMessage.test(errorMessage)) {
            // console.log('Chunk load failed. Reloading the page to fix the issue.');
            window.location.reload();
        }
    }
}